import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {actions} from './action'
import {actionTypes} from './constants'
import {service} from './service'
import {LoanEligibilityLogParams} from '../Model'

function* getLoanEligibilityLogSaga(action: ActionModel) {
  try {
    // ActionModel.payload is typed as a string map; the report params include numbers (page, limit)
    const params = action.payload as unknown as LoanEligibilityLogParams
    yield delay(500)
    const response: ResponseModel = yield call(service.getLoanEligibilityLog, params)
    yield put(actions.getLoanEligibilityLogSuccess(response?.data?.data))
    yield put(actions.getLoanEligibilityLogFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getLoanEligibilityLogFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_LOAN_ELIGIBILITY_LOG_START, getLoanEligibilityLogSaga)
}
